import useAuth from 'Hooks/useAuth';
import { string } from 'prop-types';
import { useCallback, useMemo, useRef, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';

import styles from './PdfViewer.less';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString();

const PdfViewer = props => {
  const { fileID } = props;
  const { token } = useAuth();

  const contentRef = useRef(null);
  const [pageHeight, setPageHeight] = useState(0);
  const [numPages, setNumPages] = useState(null);

  const onDocumentLoadSuccess = useCallback(({ numPages: value }) => {
    setNumPages(value);
    if (contentRef.current) {
      setPageHeight(contentRef.current.clientHeight - 16);
    }
  }, []);

  const file = useMemo(() => {
    return {
      url: `/api/file/files/${fileID}`,
      httpHeaders: { Authorization: token },
      withCredentials: true,
    };
  }, [fileID, token]);

  return (
    <div className={styles.content} ref={contentRef}>
      <div className={styles.body}>
        <Document file={file} onLoadSuccess={onDocumentLoadSuccess} loading="Loading...">
          {Array.from(new Array(numPages), (el, index) => (
            <Page
              key={`page_${index + 1}`}
              pageNumber={index + 1}
              height={pageHeight}
              renderTextLayer={false}
              renderAnnotationLayer={false}
            />
          ))}
        </Document>
      </div>
    </div>
  );
};

PdfViewer.propTypes = {
  fileID: string.isRequired,
};

export default PdfViewer;
